import { Box, BoxProps, Heading } from "@chakra-ui/react";

import { MovieDetailCard as MovieDetail } from "@picovico/ui";
import { MovieDetailCardProps } from "@picovico/ui/@types/MovieDetailCard";
import { convertMinutesToHours } from "@picovico/utils";
import { format } from "date-fns";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAppSelector } from "store";
import { useLazyGetMovieDetailQuery } from "store/services/movie";

export function MovieDetailCard({
  containerProps,
  showVideo = false,
  headingProps,
  ...props
}: Pick<MovieDetailCardProps, "showVideo"> & {
  containerProps?: BoxProps;
  headingProps: BoxProps;
}) {

  const router = useRouter();
  const { company_idx } = useAppSelector((state) => state.config);
  const movieId = router?.query?.movieIdx;
  const [getMovieDetail, { data: movieDetail }] = useLazyGetMovieDetailQuery(
    {},
  );

  useEffect(() => {
    if (movieId) {
      getMovieDetail({
        idx: movieId,
        company_idx,
      });
    }
  }, [movieId, getMovieDetail, company_idx]);

  if (router.isReady && !movieId)
    return <h1>This page doesn&apos;t have movie id in the url. </h1>;

  return movieDetail?.data ? (
    <Box {...containerProps}>
      <Heading
        as="h1"
        size={{ base: "lg", sm: "lg", md: "xl" }}
        textTransform="uppercase"
        mb="1rem"
        textAlign={{
          base: "center",
          md: "left",
          lg: "left",
          xl: "left",
        }}
        {...headingProps}
      >
        Movie Detail
      </Heading>
      <MovieDetail
        {...{
          movieTitle: movieDetail?.data.name,
          movieDescription: movieDetail?.data.description,
          rollQuality: movieDetail?.data?.roll_quality,
          duration: convertMinutesToHours(movieDetail?.data?.duration),
          director: movieDetail?.data?.director,
          cast: movieDetail?.data?.cast,
          release_date: format(
            new Date(movieDetail?.data?.release_date),
            "MMMM d yyyy",
          ),
          genre: movieDetail?.data?.genre,
          videoLink: movieDetail?.data?.trailer,
          poster: movieDetail?.data?.poster,
          banner: movieDetail?.data?.banner,
          showVideo,
          ...props,
        }}
      />
    </Box>
  ) : null;
}
